import { Form } from 'react-bootstrap';
import { FieldHookConfig, useField } from 'formik';

interface OtherProps {
  label: string;
}

export default function TextInput(props: OtherProps & FieldHookConfig<string>) {
  // useField() returns [formik.getFieldProps(), formik.getFieldMeta()]
  // which we can spread on <input> and also replace ErrorMessage entirely.
  const [field, meta] = useField({ ...props });
  return (
    <>
      <Form.Label className="ec-modal-label">{props.label}</Form.Label>
      <Form.Control
        className="ec-modal-input"
        {...field}
        name={props.name}
        type={props.type}
        placeholder={props.placeholder}
        inputMode={props.inputMode}
        autoComplete={props.autoComplete}
      />
      <Form.Text className="ec-modal-error-msg">
        {meta.touched && meta.error ? (
          // <div className="error">{meta.error}</div>
          <>{meta.error}</>
        ) : null}
      </Form.Text>
    </>
  );
}
